import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Media, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { handleResponse } from '../utils/handlers';
import { ReactComponent as DocumentIcon } from 'bootstrap-icons/icons/file-earmark.svg';
import moment from 'moment';

import styles from './ConsignmentPods.module.css';

function ConsignmentPod(props) {

    let history = useHistory();

    var fileUrl = `api/pod/${props.pod.id}/file`;

    var viewFile = (e) => {
        history.push(`/consignment/${props.consignmentId}/pods/${props.pod.id}`);
    };

    return (
        <React.Fragment>
            <Media>
                <Media body>
                    <Media heading>
                        { props.pod.status }
                    </Media>
                    <p>
                        Date: {moment(props.pod.podDate).format('YYYY-MM-DD')}<br />
                        Signed By: {props.pod.signedBy}<br />
                        Information: {props.pod.podInformation}
                    </p>
                </Media>
                {
                    props.pod.signatureFile &&
                    <Media right>
                        <div className={styles.documentControl}>
                            <Button outline color="primary" onClick={viewFile} block><DocumentIcon />View</Button>
                        </div>
                    </Media>
                }
            </Media>
        </React.Fragment>
        );
}

function ConsignmentPods(props) {

    let history = useHistory();

    let { consignmentId } = useParams();

    const [pods, setPods] = useState([]);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        setBusy(true);
        fetch(`api/consignments/${consignmentId}/pods`,
            {
                credentials: 'include'
            })
            .then(handleResponse)
            .then(data => {
                setPods(data);
                setBusy(false);
            })

    }, [consignmentId]);

    return busy ?
        <BusyIndicator isBusy={busy} /> : (
            <React.Fragment>
                {
                    pods && pods.map((pod, index) => <ConsignmentPod key={`pod_${index}`} pod={pod} consignmentId={consignmentId} />)
                }
                <Button color="primary" onClick={e => history.push(`/consignment/${consignmentId}`)} block>Back</Button>
        </React.Fragment>
        );
}

export { ConsignmentPods };